import axios from "./axios";

export const contractLinesApi = {
  getContractLines: (projectId, params = {}) => {
    return axios.get(`/projects/${projectId}/contract_lines`, { params });
  },

  getContractLine: (projectId, contractLineId, params = {}) => {
    return axios.get(`/projects/${projectId}/contract_lines/${contractLineId}`, { params });
  },

  createContractLine: (projectId, contractLine) => {
    return axios.post(`/projects/${projectId}/contract_lines`, {
      contract_line: contractLine,
    });
  },

  updateContractLine: (projectId, contractLineId, contractLine) => {
    return axios.put(`/projects/${projectId}/contract_lines/${contractLineId}`, {
      contract_line: contractLine,
    });
  },

  deleteContractLine: (projectId, contractLineId) => {
    return axios.delete(`/projects/${projectId}/contract_lines/${contractLineId}`);
  },

  registerProgress: (projectId, contractLineId, completedQuantity) => {
    return axios.post(`/projects/${projectId}/contract_lines/${contractLineId}/register_progress`, {
      completed_quantity: completedQuantity,
    });
  },

  exportContractLines: (projectId, settings = {}) => {
    return axios.get(`/projects/${projectId}/contract_lines/export`, {
      params: settings,
      responseType: "blob",
    });
  },
};

